import { Button } from "@mui/material";
import { GridColTypeDef } from "@mui/x-data-grid-pro";
import { Form } from "react-router-dom";

interface ActionFunctionParams<T> {
  row: T;
}

type HTTPMethod = "get" | "post" | "put" | "delete" | "patch";

interface ActionReturn {
  method: HTTPMethod;
  action: string;
}

type ActionFunction<T> = (params: ActionFunctionParams<T>) => ActionReturn | null;

export function actionColDef<T>(actionFn: ActionFunction<T>, label: string | React.ReactNode): GridColTypeDef {
  return {
    renderCell({ row }) {
      if (!row) return null;
      const action = actionFn({ row });
      if (!action) return null;
      return (
        <Form method={action.method} action={action.action}>
          {typeof label === "string" ? <Button type="submit">{label}</Button> : label}
        </Form>
      );
    },
  };
}
